import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const suburbs = ['Balcatta', 'Stirling', 'Karrinyup', 'Innaloo', 'Scarborough', 'Doubleview', 'Osborne Park', 'Tuart Hill', 'Yokine', 'Mount Lawley', 'Maylands', 'Inglewood', 'Bayswater', 'Morley', 'Dianella', 'Carine', 'Duncraig', 'Greenwood', 'Kingsley', 'Padbury', 'Hillarys', 'Sorrento', 'Marmion', 'Mullaloo', 'Joondalup', 'Currambine', 'Wanneroo', 'Subiaco', 'Cottesloe', 'Nedlands', 'Perth CBD'];
export function SuburbsMap() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-723" data-mp="buhhgapvhi0g">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-724" data-mp="bt6e2c0cac9v">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-725" data-mp="6uv8idh2unxg">
          {/* Left: Map */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5" data-id="element-726" data-mp="14c3ordwgxwg4">
            <div className="relative aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden bg-brand border border-stone-200 shadow-xl" data-id="element-727" data-mp="2auceeq6majil">
              <iframe title="Langler Air Balcatta location" src="https://www.openstreetmap.org/export/embed.html?bbox=115.7100%2C-32.0500%2C115.9300%2C-31.7000&amp;layer=mapnik&amp;marker=-31.8753%2C115.8200" className="w-full h-full opacity-95" loading="lazy" aria-label="Map showing Langler Air in Balcatta, Perth" data-id="element-728" data-mp="2etbgm30ys26c"></iframe>

              <div className="absolute bottom-5 left-5 right-5 bg-white rounded-2xl p-5 shadow-2xl border border-stone-200" data-id="element-729" data-mp="1vy3ernite45n">
                <div className="flex items-start gap-3" data-id="element-730" data-mp="3qat9g7h0bhe3">
                  <div className="w-10 h-10 rounded-full bg-brand text-white flex items-center justify-center flex-shrink-0" data-id="element-731" data-mp="3q8732b5ur7xg">
                    <MapPin size={16} data-id="element-732" data-mp="y30t79iszev0" />
                  </div>
                  <div data-id="element-733" data-mp="y1fztn8861yq">
                    <div className="text-base font-bold tracking-tight text-ink leading-tight" data-id="element-734" data-mp="u15tg9git9jc">
                      Langler Air Workshop
                    </div>
                    <div className="text-sm text-stone-600 mt-1 leading-snug" data-id="element-735" data-mp="p3njcfqroo9r">
                      Unit 2/3 Cressall Rd, Balcatta WA 6021
                    </div>
                    <a href="https://maps.google.com/?q=Unit+2%2F3+Cressall+Rd%2C+Balcatta+WA+6021" target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-xs font-bold text-brand hover:underline underline-offset-2" data-id="element-736" data-mp="1hqi1v740xdkl">
                      Open in Google Maps →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Suburbs grid */}
          <div className="lg:col-span-7" data-id="element-737" data-mp="2833kild998j5">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-738" data-mp="2cz247vnn22d8">
              Where We Install
            </div>
            <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-ink leading-tight mb-6" data-id="element-739" data-mp="2hxn762u9z05d">
              All Perth metro from Balcatta.
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed mb-8 max-w-lg" data-id="element-740" data-mp="2qylbyncjfbp0">
              We install across all of Perth metropolitan area from our Balcatta
              workshop. We also travel for ducted jobs across WA, just ask.
            </p>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-2" data-id="element-741" data-mp="35oj41edl8ljh">
              {suburbs.map((suburb, i) => <div key={i} className={`text-sm flex items-center gap-2 py-1 ${suburb === 'Balcatta' ? 'font-bold text-brand' : 'text-stone-700'}`} data-id="element-742" data-mp="2x0mzawzu0yi0" data-mpi={i}>
                  <span className={`w-1.5 h-1.5 rounded-full ${suburb === 'Balcatta' ? 'bg-brand' : 'bg-stone-300'}`} data-id="element-743" data-mp="35v9y3aazqcla"></span>
                  {suburb}
                  {suburb === 'Balcatta' && <span className="text-[10px] uppercase tracking-wider font-semibold text-accent ml-1" data-id="element-744" data-mp="2s2boaixswhy7">
                      base
                    </span>}
                </div>)}
            </motion.div>

            <div className="mt-8 p-5 bg-white border border-stone-200 rounded-2xl flex items-start gap-3 shadow-md" data-id="element-745" data-mp="7a02o8i16koc">
              <div className="w-2 h-2 rounded-full bg-success mt-2 flex-shrink-0 animate-pulse" data-id="element-746" data-mp="2ekpzjvreuti"></div>
              <p className="text-sm text-stone-700 leading-relaxed" data-id="element-747" data-mp="1kc7klt1xlquh">
                <strong className="text-ink" data-id="element-748" data-mp="1parau5nk5osn">Not on the list?</strong> Call us.
                We have installed everywhere from Two Rocks to Mandurah, and
                travel further for ducted jobs across regional WA.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}